import React, { useState, useEffect, useRef } from 'react';
import { apiClient } from '../../components/api/ApiClient';

function Country() {
    const [countries, setcountries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const tableRef = useRef(null);

    useEffect(() => {
        async function fetchData() {
            setLoading(true);
            try {
                const data = await apiClient('/internal-network/api/location/', { method: 'GET' });
                setcountries(data);
                setError(null);
            } catch (err) {
                console.error("خطا در دریافت اطلاعات کشورها:", err);

                setError(`خطا در دریافت اطلاعات: ${err.message}`);
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, []);


    useEffect(() => {

        if (!loading && countries.countries.length > 0 && window.jQuery && window.jQuery.fn.DataTable && tableRef.current) {
            if (window.jQuery.fn.DataTable.isDataTable(tableRef.current)) {
                window.jQuery(tableRef.current).DataTable().destroy();
            }
            const dataTable = window.jQuery(tableRef.current).DataTable({
                "dom": '<"row mb-3 text-dark"<"col-md-6"l><"col-md-6 search-label-after"f>><"row"<"col-sm-12"tr>><"row text-dark"<"col-sm-12 col-md-5"i><"col-sm-12 col-md-7"p>>',
                "language": {
                    "sEmptyTable": "هیچ داده‌ای در جدول وجود ندارد",
                    "sInfo": "نمایش _START_ تا _END_ از _TOTAL_ ردیف",
                    "sInfoEmpty": "نمایش ۰ تا ۰ از ۰ ردیف",
                    "sInfoFiltered": "(فیلتر شده از _MAX_ ردیف)",
                    "sInfoThousands": ",",
                    "sLengthMenu": "نمایش _MENU_ ردیف",
                    "sLoadingRecords": "در حال بارگذاری...",
                    "sProcessing": "در حال پردازش...",
                    "sSearch": "جستجو:",
                    "sZeroRecords": "هیچ ردیفی مطابق با جستجوی شما پیدا نشد",
                    "oPaginate": {
                        "sFirst": "اولین",
                        "sLast": "آخرین",
                        "sNext": "بعدی",
                        "sPrevious": "قبلی"
                    },
                    "oAria": {
                        "sSortAscending": ": فعال‌سازی برای مرتب‌سازی صعودی ستون",
                        "sSortDescending": ": فعال‌سازی برای مرتب‌سازی نزولی ستون"
                    }
                },

                "pagingType": "full_numbers",
                "searching": true,
                "lengthChange": true,
                "ordering": true,
                "info": true,
                "destroy": true
            });
            return () => {
                if (window.jQuery && window.jQuery.fn.DataTable.isDataTable(tableRef.current)) {
                    try { window.jQuery(tableRef.current).find('[data-bs-toggle="tooltip"]').tooltip('dispose'); } catch (e) {}
                    dataTable.destroy(false);
                }
            };
        }
    }, [countries, loading]);

    if (loading) {
        return <div className="text-center py-5">در حال بارگذاری اطلاعات کشورها...</div>;
    }

    if (error) {
        return <div className="text-center py-5 text-danger">{error}</div>;
    }

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card stretch stretch-full">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-hover" id="CountryList" ref={tableRef}>
                                <thead>
                                    <tr>
                                        <th>کد</th>
                                        <th>عنوان کشور</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {countries.countries.length > 0 ? (

                                        countries.countries.map((country, index) => (
                                            <tr key={index} className="single-item">
                                                <td className="fw-bold text-dark">{country.code}</td>
                                                <td>{country.name}</td>
                                            </tr>
                                        ))
                                    ) : (

                                        <tr>
                                            <td colSpan="3" className="text-center">هیچ کشوری برای نمایش وجود ندارد.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Country;